import { combineReducers } from "@reduxjs/toolkit";
import { createMigrate, PersistConfig, persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { configureStore } from "@reduxjs/toolkit";
import editorSlice from "./reducers/editorSlice";
import projectSlice from './reducers/projectSlice'
import { EditorState } from "utils/interface.utils";
import userSlice from "./reducers/userSlice";

const rootPersistConfig = {
  key: 'root',
  storage,
}

const editorMigrations = {
  1: (state: any) => ({
    ...state,
    history: [],
    future: [],
    isGestureInProgress: false,
  }),
}

const editorPersistConfig: PersistConfig<EditorState> = {
  key: 'editor',
  storage,
  blacklist: ['history', 'future', 'isGestureInProgress', 'hasUnsavedChanges'],
  version: 1,
  migrate: createMigrate(editorMigrations, { debug: false }),
}

const projectPersistConfig = {
  key: 'project',
  storage,
}

const userPersistConfig = {
  key: 'user',
  storage,
}

const rootReducer = combineReducers({
  editor: persistReducer(editorPersistConfig, editorSlice),
  project: persistReducer(projectPersistConfig, projectSlice),
  user: persistReducer(userPersistConfig, userSlice),
})

const persistedReducer = persistReducer(rootPersistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          'persist/PAUSE',
          'persist/PURGE',
          'persist/REGISTER'
        ],
      },
    }),
})

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;